module.exports = __webpack_public_path__ + "img/奖励-1.93f68c20.jpg";